import { SAFEA_V3_ENABLED } from '~/constants/_core/safea-v3';
import storage from '~/helpers/_core/storage';

const _handleNoCurrentRole = async (
  store,
  redirect,
  route,
  query,
  path
) => {
  const hasOnlyOneRights = store.getters['_core/auth/hasOnlyOneRights'];
  if (hasOnlyOneRights) {
    const firstRights = store.getters['_core/auth/getFirstRights'];
    const assumedRole = await store.dispatch('_core/auth/actionAssumeRole', firstRights);

    if (!assumedRole) {
      return redirect('/role-not-found');
    }

    return redirect({
      query,
      path
    });
  }

  const isFirstAccess = store.getters['_core/auth/isFirstAccess'];
  if (isFirstAccess && !route.path.startsWith('/welcome')) {
    return redirect({
      path: `/welcome`,
      query
    });
  }

  const hasRights = store.getters['_core/auth/hasRights'];
  if (hasRights && !route.path.startsWith('/welcome')) {
    return redirect({
      path: `/welcome`,
      query
    });
  }
};

export default async ({ app, store, route, redirect }) => {
  if (SAFEA_V3_ENABLED) {
    return;
  }

  const hasCurrentRole = store.getters['_core/auth/hasCurrentRole'];
  const isAuthenticated = store.getters['_core/auth/isAuthenticated'];

  const query = Object.assign({}, route.query);
  const returnUrl = query.returnUrl;
  const finalReturnUrl = query.returnUrl || storage.session.returnUrl || route.path || '/';

  delete query.returnUrl;
  delete query.signoutRedirectUrl;

  if (query.tokenId) {
    delete query.tokenId;

    if (hasCurrentRole) {
      redirect({
        query : query,
        path  : finalReturnUrl
      });
    }
  }

  if (!isAuthenticated) {
    app.$token.clear();
    return store.dispatch('_core/auth/redirectToSignOutUrl', {
      redirect,
      route: {
        query : query,
        path  : returnUrl || route.path || '/'
      }
    });
  }

  if (store.state._core.user.temporaryPassword && !store.state._core.auth.impersonatedBy) {
    if (!route.path.startsWith('/auth/password/expired')) {
      storage.session.returnUrl = query.returnUrl || storage.session.returnUrl;
      return redirect({
        path  : `/auth/password/expired`,
        query : query
      });
    }

    return;
  }

  const noRights = !store.getters['_core/auth/hasRights'];
  if (noRights) {
    return redirect('/role-not-found');
  }

  if (!hasCurrentRole) {
    storage.session.returnUrl = query.returnUrl || storage.session.returnUrl;
    return await _handleNoCurrentRole(
      store,
      redirect,
      route,
      query,
      finalReturnUrl
    );
  }

  if (hasCurrentRole && (query.returnUrl ?? storage.session.returnUrl)) {
    storage.session.returnUrl = null;
    return redirect({
      query : query,
      path  : finalReturnUrl
    });
  }
};
